import { render, staticRenderFns } from "./Hospital.vue?vue&type=template&id=49e39218&scoped=true&"
import script from "./Hospital.vue?vue&type=script&lang=js&"
export * from "./Hospital.vue?vue&type=script&lang=js&"
import style0 from "./Hospital.vue?vue&type=style&index=0&id=49e39218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e39218",
  null
  
)

export default component.exports